import { type FC, memo } from 'react';
import { MaskVariant } from '../../enums';
import { Props } from './types';
import css from './style.module.css';

const Path: FC<Props> = ({ id, size, variant }) => {
  if (variant === MaskVariant.LEFT) {
    switch (size) {
      case 16:
        return (
          <path
            id={id}
            d="M2 13.3C3.25 11.89 4 10.03 4 8C4 5.99 3.25 4.12 2 2.71C3.46 1.05 5.61 0 8 0C12.2 0 16 3.58 16 8C16 12.2 12.2 16 8 16C5.61 16 3.46 14.96 2 13.3Z"
          />
        );

      case 24:
        return (
          <path
            id={id}
            d="M3 19.96C4.86 17.78 6 14.99 6 12C6 9.01 4.86 6.22 3 4.04C5.2 1.57 8.43 0 12 0C18 0 24 5.38 24 12C24 18 18 24 12 24C8.43 24 5.2 22.43 3 19.96Z"
          />
        );

      case 28:
        return (
          <path
            id={id}
            d="M3.5 23.2604C5.67827 20.7924 7 17.5506 7 14C7 10.4494 5.67827 7.20758 3.5 4.73962C6.06531 1.83314 9.81857 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C9.81857 28 6.06531 26.1669 3.5 23.2604Z"
          />
        );

      case 40:
        return (
          <path
            id={id}
            d="M5 33.2291C8.11182 29.7035 10 25.0722 10 20C10 14.9278 8.11182 10.2965 5 6.77088C8.66472 2.61877 14.0265 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C14.0265 40 8.66472 37.3812 5 33.2291Z"
          />
        );
    }
  }

  const radius = size / 2;

  return <circle id={id} cx={radius} cy={radius} r={radius} />;
};

export const Entry: FC<Props> = memo(function Component({
  id,
  size,
  variant,
}: Props) {
  const defsId = `${id}--defs`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={css.root} aria-hidden>
      <defs>
        <clipPath id={id}>
          <Path id={defsId} size={size} variant={variant} />
        </clipPath>
      </defs>
    </svg>
  );
});
